import React from 'react'
import Nav from '@mc/navigation'
import { StepsText } from '../StepsText'
import { CheckoutSteps, Logo, LogIn } from './components'
import { useNavigationSteps } from './useNavigationSteps'

export const NavigationMobile = () => {
  const {
    context: { hideNavbarElements, theme },
  } = useNavigationSteps()

  return (
    <Nav
      as='div'
      contained={false}
      className={hideNavbarElements ? '' : 'mc-my-3'}
      background={theme === 'gradient' ? 'transparent' : 'solid'}
      dynamicHeight
    >
      <Nav.Left className='col-4'>
        <Logo />
      </Nav.Left>

      <Nav.Center className='col-4'>
        <StepsText />
      </Nav.Center>

      <Nav.Right className='col-4 justify-content-end'>
        <LogIn />
      </Nav.Right>

      <div className='col-12'>
        <CheckoutSteps
          className='row no-gutters justify-content-center flex-nowrap'
          stepClassName='col-4'
        />
      </div>
    </Nav>
  )
}
